export enum UserState {
  UNKNOW = 0,
  OK,
  NOTEXISTS,
  LOCKED
}
